import alerts from './alerts'
import authenticated from './authenticated'

export default {
  alerts,
  authenticated
}